export default "__VITE_ASSET__CMgkFi2I__"